import { render, staticRenderFns } from "./usercoupon.vue?vue&type=template&id=2f7e65c2&scoped=true"
import script from "./usercoupon.vue?vue&type=script&lang=js"
export * from "./usercoupon.vue?vue&type=script&lang=js"
import style0 from "./usercoupon.vue?vue&type=style&index=0&id=2f7e65c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f7e65c2",
  null
  
)

export default component.exports